<script setup lang="ts">
import { inject, Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTourManagementStore } from '@/store/TourManagementStore';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import VersionRevertTable from '@/components/VersionRevertTable.vue';

const dialogRef = inject('dialogRef') as Ref;
const onSelectVersion = dialogRef?.value?.options.emits.onSelectVersion;
const versions = dialogRef.value.options.data.versions;

const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const tourManagementStore = useTourManagementStore();

const isLoading = ref(false);

const handleCloseModal = () => {
  dialogRef.value.close();
};

const handlePreviewVersion = (fileName: string, type: string) => {
  isLoading.value = true;
  tourManagementStore
    .getPreviewFileTourGateDes(fileName)
    .then((response) => {
      onSelectVersion({
        tourGatewayDestList: response.data,
        file: fileName,
        type
      });
      if (type === 'REVERT') {
        dialogRef.value.close();
      }
    })
    .catch(() => {
      toast.add({ severity: 'error', summary: '', detail: t('notification.unexpected_error'), life: 5000 });
    })
    .finally(() => {
      isLoading.value = false;
    });
};
</script>
<template>
  <div>
    <LoadingSpinner v-if="isLoading" />
    <div>
      <div>
        <VersionRevertTable :versions="versions" @handlePreview="(fileName, type) => handlePreviewVersion(fileName, type)" />
      </div>
      <div class="mt-1 text-center">
        <Button id="close-btn" :label="$t('common.buttons.close')" @click="handleCloseModal()" />
      </div>
    </div>
  </div>
</template>
